// extracted by mini-css-extract-plugin
export default {"message":"styles_message__ugxdm","innerMessage":"styles_innerMessage__F+-gq","spin":"styles_spin__FNr1l"};